<template>
    <div :class="searchAutocompleteClass">
        <div class="search-network-users__search-field">
            <div :class="iconClass">
                <common-icon :name="iconName" size="large"></common-icon>
            </div>

            <input
                v-model="searchTerm"
                type="text"
                class="search-autocomplete__input"
                :placeholder="placeholder"
                :disabled="false"
                @keyup="inputChange"
                @focus="inputFocus"
                @blur="inputBlur"
            />
        </div>
        <div class="network-users">
            <div
                v-for="(user, index) in items"
                :key="index"
                :class="[{ 'network-user-selected': user.user ? selectedItems[user.user.id] : false }, 'network-user']"
                @click="selectUser(user)"
            >
                <div>
                    <common-user-avatar
                        size="user-menu"
                        :user="user.user ? user.user : user.practice"
                        :isUserProfileLinkEnabled="false"
                    ></common-user-avatar>
                </div>
                <div>
                    <p>{{ user.user ? user.user?.firstName + ' ' + user.user?.lastName : user.practice?.name }}</p>
                    <p v-if="user.user">{{ user.user.specialities[0].speciality.name }}</p>
                </div>
            </div>
            <div v-if="items.length === 0 && showLoading">
                <p class="search-network-members__message">{{ $t('modals.search_network_members.loading_message') }}</p>
            </div>
            <div v-if="items.length === 0 && !showLoading">
                <p class="search-network-members__message">{{ $t('modals.search_network_members.no_member_found') }}</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            placeholder: { type: String, required: true },
            icon: { type: String, default: 'member' },
            iconPosition: { type: String, default: 'left' },
            iconBackground: { type: String, default: 'secondary' },
            selectedUsers: { type: Array, required: true },
            items: { type: Array, required: true },
            showLoading: { type: Boolean, required: true },
        },

        data() {
            return {
                selectedItems: {},
                searchTerm: '',
                isFocused: false,
                limit: 20,
                offset: 0,
            }
        },

        computed: {
            searchAutocompleteClass() {
                return {
                    [`search-autocomplete__search-input--${this.iconPosition}`]: true,
                    'search-autocomplete__search-input': true,
                    'form-input-text': true,
                }
            },

            iconName() {
                if (this.iconBackground === 'primary' && this.isFocused) return `${this.icon}-white`
                return `${this.icon}-gray`
            },

            iconClass() {
                return {
                    'search-autocomplete__icon': true,
                    [`search-autocomplete__icon--${this.iconPosition}`]: true,
                    [`search-autocomplete__icon--color-${this.iconBackground}`]: this.isFocused,
                }
            },
        },

        methods: {
            inputChange() {
                this.emitEvent({ name: 'input-change', payload: { searchTerm: this.searchTerm } })
            },

            selectUser(event) {
                const user = {
                    id: event.user.id,
                    email: event.user.email,
                }
                this.emitEvent({ name: 'user-selected', payload: user })
            },

            inputFocus() {
                this.isFocused = true
            },

            inputBlur() {
                this.isFocused = false
            },
            highlightSelectedUsers() {
                this.selectedItems = {}
                this.selectedUsers.forEach((user) => {
                    this.$set(this.selectedItems, user.id, true)
                })
            },
        },
        watch: {
            selectedUsers() {
                this.highlightSelectedUsers()
            },
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';
    .network-user {
        display: flex;
        padding: 10px;
        cursor: pointer;
    }
    .network-user > div:last-child {
        @include breakpoint(smartphone-large) {
            width: 200px;
        }
        width: 300px;
        margin-left: 15px;
    }
    .network-user > div:first-child {
        margin-left: 30px;
    }
    .network-user p:first-child {
        font-weight: 500;
    }
    .network-user p:last-child {
        font-weight: 200;
    }
    .network-user:hover {
        background-color: #f5fbfe;
    }
    .network-user-selected {
        background-color: #e8f7ff;
    }
    .network-users {
        overflow-y: scroll;
        max-height: 210px;
    }
    .search-network-users__search-field {
        margin-left: 30px;
        margin-top: 30px;
        margin-right: 30px;
    }
    .search-network-users__search-field > div:first-child {
        margin-right: 30px;
    }
    .search-network-members__message {
        margin: 30px;
        text-align: center;
    }
</style>
